import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import WareHouseList from "../pages/WareHouse/WareHouseList";
import CreateWarehouse from "../pages/WareHouse/CreateWarehouse";
import EditWarehouse from "../pages/WareHouse/EditWarehouse";
//@ts-ignore
import { PermissionRequired, AccessControl} from "@careinfo/permission-required";

export const queryClient = new QueryClient()

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<WareHouseList />} />
          <Route path="/warehouse" element={<WareHouseList />} />
          <Route path="/create" element={
            <AccessControl
            children={
            <CreateWarehouse />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={<PermissionRequired/>}
            />
          } />
          <Route path="/edit/:id" element={
              <AccessControl
              children={
                <EditWarehouse />
              }
              allowedPermissions={["can_update_setting"]}
              renderNoAccess={<PermissionRequired/>}
              />
            } />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>

  );
};

export default Router;